export default __webpack_public_path__ + "static/media/thankyou.dd123968.webp";